module.exports = __webpack_public_path__ + "static/saisie-5421364ad3cc6848a4ff343c146b08be.jpg";